import React, { useState, useEffect } from "react";
import "./SideBar.css";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { SideBtn, CheckLabel, UnderDevelopment } from "../../Components";
import logo from "../../assets/images/svg/logo.svg";
import { Link, useLocation } from "react-router-dom";
import Modal from "react-modal";
import axios from "axios";
import Cookies from 'js-cookie';
import { toast } from 'react-toastify'; 
import Skeleton from 'react-loading-skeleton';

import SubModal from '@mui/material/Modal';
import Box from '@mui/material/Box';


const SideBar = ({ url, data, selectedFilters, setSelectedFilters, searchQuery, setSearchQuery, callChangeReportFilters, reportObject, loading, translations }) => {
  const dataSection = data
    ? data?.find((item) => item.section === "Regulation List" || item.section === "Amendment List" || item.section == "Reports List" || item.section == "Reminders List" || item.section == "Search List" || item.section == "Notes List")
    : null;

  const [areas_of_law, setAreasofLaw] = useState([]);
  const [topics, setTopics] = useState([]);
  const [jurisdictions, setJurisdictions] = useState([]);


  const [subPopup, setSubPopup] = useState(false);
  const [messagePopup, setMessagePopup] = useState("")   

  const handleCloseSubPopup = () => {
      setSubPopup(false);
  };
  const pattern = /^\/dashboard\/folders/; //\/\w+$

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };


  useEffect(() => {
    const areasOfLaw = dataSection?.data?.content?.areas_of_law || [];
    const topics = dataSection?.data?.content?.topics || [];
    const jurisdictions = dataSection?.data?.content?.jurisdictions || [];
    setAreasofLaw(areasOfLaw);
    setTopics(topics);
    setJurisdictions(jurisdictions);
  }, [dataSection]);


  let isChecking = false; // Flag to track ongoing check operation

  const handleCheckboxChange = async (type, name) => {
    if (isChecking) {
      return; // Do nothing if a check operation is already in progress
    }

    isChecking = true; // Set the flag to indicate an ongoing check operation

    try {
      await new Promise((resolve) => setTimeout(resolve)); // Wait for the next event loop iteration

      setSelectedFilters((prevSelectedFilters) => {
        const updatedFilters = { ...prevSelectedFilters };

        if (!updatedFilters[type]) {
          updatedFilters[type] = [];
        }

        if (updatedFilters[type].includes(name)) {
          updatedFilters[type] = updatedFilters[type].filter(
            (filter) => filter !== name
          );
        } else {
          updatedFilters[type].push(name);
        }

        return updatedFilters;
      });
    } finally {
      isChecking = false; // Reset the flag after the check operation is completed
    }
  };



  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const [activeButton, setActiveButton] = useState("Dashboard");

  const handleButtonClick = (title) => {
    setActiveButton(title);
  };

  const location = useLocation();
  const [showBtns, setShowBtns] = useState(location.pathname === "/dashboard");



  const lastSegment = window.location.pathname.split('/').filter(Boolean).pop();


  useEffect(() => {
    setShowBtns(location.pathname === "/dashboard");
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      setActiveButton("Dashboard");
    } else if (location.pathname === "/dashboard/amendments") {
      setActiveButton("Amendments");
    } else if (location.pathname === "/dashboard/reminders") {
      setActiveButton("Reminders");
    } else if (location.pathname === "/dashboard/notes") {
      setActiveButton("Notes");
    } else if (location.pathname === "/dashboard/search") {
      setActiveButton("Search");
    } else if (location.pathname === "/dashboard/regulation") {
      setActiveButton("Regulations");
    } else if (location.pathname === "/dashboard/chatbot") {
      setActiveButton("Chatbot");
    } else if (location.pathname === "/dashboard/profile") {
      setActiveButton("Settings");
    }
  }, [location.pathname]);


  // check if filter already exist 
  const handleExist = (field, name) => {
    let isChecked = false;
    if (selectedFilters && selectedFilters[field]) {
      if (selectedFilters[field].includes(name)) {
        isChecked = true;
      }
    } else {
      isChecked = false;
    }

    return isChecked;
  }


  // This function for update report only   
  const handleApplyFilters = async () => {

    if (selectedFilters && selectedFilters.area_of_laws) {
      reportObject['query']['area_of_laws'] = selectedFilters.area_of_laws.join(",");
    }
    if (selectedFilters && selectedFilters.topics) {
      reportObject['query']['topics'] = (selectedFilters.topics.join(","));
    }
    if (selectedFilters && selectedFilters.jurisdiction) {
      reportObject['query']['jurisdiction'] = (selectedFilters.jurisdiction.join(","));
    }

    const apiUrl = `${url}/api/method/projectx.projectx.doctype.law_report.law_report.law_report`;
    const data = reportObject;
    try {
      const apiKey = Cookies.get('api_key');
      const apiSecret = Cookies.get('api_secret');
      const response = await axios.put(apiUrl, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `token ${apiKey}:${apiSecret}`,
        },
      });
      if (response.data && response.data.status_code === 200) {
        toast.success(translations?.message?.folderUpdatedSuccessfully ? translations.message.folderUpdatedSuccessfully:'Folder updated successfully.');
        callChangeReportFilters();
      } else {
        toast.error(translations?.message?.failedUpdateFolder ? translations.message.failedUpdateFolder:'Failed to update this folder.');
      }

      if (response?.data?.status_code === 202) {
        setSubPopup(true);
      }
    } catch (error) {
      if (error?.response?.data?.status_code === 202) {
        setSubPopup(true);
        setMessagePopup(error?.response?.data?.message)
      }
      toast.error(translations?.message?.failedUpdateFolder ? translations.message.failedUpdateFolder:'Failed to update this folder.');
    }
  }


  return (
    <div style={{ height: "100vh", display: "flex" }}>
      <Sidebar style={{ height: "100vh" }}>
        {showBtns ? (
          <Menu> 
            <a href={"/dashboard"}>
              <MenuItem style={{ textAlign: "center" }}>
                <img src={logo} alt="Logo" />
              </MenuItem>
            </a>
            <a href="/dashboard">
              <div
                onClick={() => handleButtonClick("Dashboard")}
              >
                <SideBtn
                  svgImage={
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_36_301)">
                        <path
                          d="M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z"
                          style={{
                            fill:
                              activeButton === "Dashboard"
                                ? "#2DB0D8"
                                : "#A3AED0",
                          }}
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_36_301">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  }
                  title={translations?.message?.dashboard ? translations.message.dashboard : "Dashboard"} 
                  isActive={activeButton === "Dashboard"}
                />
              </div>
            </a>
           
            <a href="/dashboard/regulation">
              <div
                onClick={() => handleButtonClick("Regulations")}
                // data-aos="fade-right"
                // data-aos-duration="1900"
              >
                <SideBtn
                  svgImage={
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.1208 22H12.8792C12.4928 22 12.1836 21.7681 12.1063 21.3816L11.7198 19.9903L11.4106 19.8357L10.1739 20.5314C9.86473 20.686 9.47826 20.686 9.24638 20.3768L7.62319 18.7536C7.3913 18.5217 7.31401 18.1353 7.4686 17.8261L8.16425 16.5894L8.00966 16.2802L6.61836 15.8937C6.30918 15.8164 6 15.5072 6 15.1208V12.8792C6 12.4928 6.23188 12.1836 6.61836 12.1063L8.00966 11.7198L8.16425 11.4106L7.4686 10.1739C7.31401 9.86473 7.31401 9.47826 7.62319 9.24638L9.24638 7.62319C9.47826 7.3913 9.86473 7.31401 10.1739 7.4686L11.4106 8.16425L11.7198 8.00966L12.1063 6.61836C12.1836 6.30918 12.4928 6 12.8792 6H15.1208C15.5072 6 15.8164 6.23188 15.8937 6.61836L16.2802 8.00966L16.5894 8.16425L17.8261 7.4686C18.1353 7.31401 18.5217 7.31401 18.7536 7.62319L20.3768 9.24638C20.6087 9.47826 20.686 9.86473 20.5314 10.1739L19.8357 11.4106L19.9903 11.7198L21.3816 12.1063C21.6908 12.1836 22 12.4928 22 12.8792V15.1208C22 15.5072 21.7681 15.8164 21.3816 15.8937L19.9903 16.2802L19.8357 16.5894L20.5314 17.8261C20.686 18.1353 20.686 18.5217 20.3768 18.7536L18.7536 20.3768C18.5217 20.6087 18.1353 20.686 17.8261 20.5314L16.5894 19.8357L16.2802 19.9903L15.8937 21.3816C15.7391 21.7681 15.43 22 15.1208 22ZM13.4203 20.4541H14.5024L14.8889 18.8309L15.2754 18.6763C15.5845 18.599 15.8164 18.4444 16.1256 18.3671L16.5121 18.1353L17.9807 18.9855L18.7536 18.2126L17.9034 16.744L18.1353 16.3575C18.2899 16.1256 18.3671 15.8164 18.4444 15.5072L18.599 15.1208L20.2222 14.7343V13.6522L18.599 13.2657L18.4444 12.8792C18.3671 12.57 18.2126 12.3382 18.1353 12.029L17.9034 11.6425L18.7536 10.1739L17.9807 9.40097L16.5121 10.2512L16.1256 10.0193C15.8937 9.86473 15.5845 9.78744 15.2754 9.71014L14.8889 9.55556L14.5024 7.93237H13.4203L13.0338 9.55556L12.6473 9.71014C12.3382 9.78744 12.1063 9.94203 11.7971 10.0193L11.4106 10.2512L9.94203 9.40097L9.16908 10.1739L10.0193 11.6425L9.78744 12.029C9.63285 12.2609 9.55556 12.57 9.47826 12.8792L9.32367 13.2657L7.70048 13.6522V14.7343L9.32367 15.1208L9.47826 15.5072C9.55556 15.8164 9.71015 16.0483 9.78744 16.3575L10.0193 16.744L9.16908 18.2126L9.94203 18.9855L11.4106 18.1353L11.7971 18.3671C12.029 18.5217 12.3382 18.599 12.6473 18.6763L13.0338 18.8309L13.4203 20.4541Z"
                        style={{
                          fill:
                            activeButton === "Regulations"
                              ? "#2DB0D8"
                              : "#A3AED0",
                        }}
                      />
                      <path
                        d="M14 18C11.7674 18 10 16.2326 10 14C10 11.7674 11.7674 10 14 10C16.2326 10 18 11.7674 18 14C18 16.2326 16.2326 18 14 18ZM14 11.8605C12.7907 11.8605 11.8605 12.7907 11.8605 14C11.8605 15.2093 12.7907 16.1395 14 16.1395C15.2093 16.1395 16.1395 15.2093 16.1395 14C16.1395 12.7907 15.2093 11.8605 14 11.8605Z"
                        style={{
                          fill:
                            activeButton === "Regulations"
                              ? "#2DB0D8"
                              : "#A3AED0",
                        }}
                      />
                      <path
                        d="M14.5 2C14.0312 2 13.7188 2.3125 13.7188 2.78125C13.7188 3.25 14.0312 3.5625 14.5 3.5625C20.5156 3.5625 25.4375 8.48438 25.4375 14.5C25.4375 20.5156 20.5156 25.4375 14.5 25.4375C8.48438 25.4375 3.5625 20.5156 3.5625 14.5C3.5625 12.3125 4.1875 10.2031 5.4375 8.40625V9.34375C5.4375 9.8125 5.75 10.125 6.21875 10.125C6.6875 10.125 7 9.8125 7 9.34375V5.4375H3.09375C2.625 5.4375 2.3125 5.75 2.3125 6.21875C2.3125 6.6875 2.625 7 3.09375 7H4.5C2.85937 9.10937 2 11.7656 2 14.5C2 21.375 7.625 27 14.5 27C21.375 27 27 21.375 27 14.5C27 7.625 21.375 2 14.5 2Z"
                        style={{
                          fill:
                            activeButton === "Regulations"
                              ? "#2DB0D8"
                              : "#A3AED0",
                        }}
                      />
                    </svg>
                  }
                  title={translations?.message?.regulations ? translations.message.regulations : "Regulations"} 
                  isActive={activeButton === "Regulations"}
                />
              </div>
            </a>
            <a href={"/dashboard/amendments"}>
              <div
                onClick={() => handleButtonClick("Amendments")}
                // data-aos="fade-right"
                // data-aos-duration="1600"
              >
                <SideBtn
                  svgImage={
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.1208 22H12.8792C12.4928 22 12.1836 21.7681 12.1063 21.3816L11.7198 19.9903L11.4106 19.8357L10.1739 20.5314C9.86473 20.686 9.47826 20.686 9.24638 20.3768L7.62319 18.7536C7.3913 18.5217 7.31401 18.1353 7.4686 17.8261L8.16425 16.5894L8.00966 16.2802L6.61836 15.8937C6.30918 15.8164 6 15.5072 6 15.1208V12.8792C6 12.4928 6.23188 12.1836 6.61836 12.1063L8.00966 11.7198L8.16425 11.4106L7.4686 10.1739C7.31401 9.86473 7.31401 9.47826 7.62319 9.24638L9.24638 7.62319C9.47826 7.3913 9.86473 7.31401 10.1739 7.4686L11.4106 8.16425L11.7198 8.00966L12.1063 6.61836C12.1836 6.30918 12.4928 6 12.8792 6H15.1208C15.5072 6 15.8164 6.23188 15.8937 6.61836L16.2802 8.00966L16.5894 8.16425L17.8261 7.4686C18.1353 7.31401 18.5217 7.31401 18.7536 7.62319L20.3768 9.24638C20.6087 9.47826 20.686 9.86473 20.5314 10.1739L19.8357 11.4106L19.9903 11.7198L21.3816 12.1063C21.6908 12.1836 22 12.4928 22 12.8792V15.1208C22 15.5072 21.7681 15.8164 21.3816 15.8937L19.9903 16.2802L19.8357 16.5894L20.5314 17.8261C20.686 18.1353 20.686 18.5217 20.3768 18.7536L18.7536 20.3768C18.5217 20.6087 18.1353 20.686 17.8261 20.5314L16.5894 19.8357L16.2802 19.9903L15.8937 21.3816C15.7391 21.7681 15.43 22 15.1208 22ZM13.4203 20.4541H14.5024L14.8889 18.8309L15.2754 18.6763C15.5845 18.599 15.8164 18.4444 16.1256 18.3671L16.5121 18.1353L17.9807 18.9855L18.7536 18.2126L17.9034 16.744L18.1353 16.3575C18.2899 16.1256 18.3671 15.8164 18.4444 15.5072L18.599 15.1208L20.2222 14.7343V13.6522L18.599 13.2657L18.4444 12.8792C18.3671 12.57 18.2126 12.3382 18.1353 12.029L17.9034 11.6425L18.7536 10.1739L17.9807 9.40097L16.5121 10.2512L16.1256 10.0193C15.8937 9.86473 15.5845 9.78744 15.2754 9.71014L14.8889 9.55556L14.5024 7.93237H13.4203L13.0338 9.55556L12.6473 9.71014C12.3382 9.78744 12.1063 9.94203 11.7971 10.0193L11.4106 10.2512L9.94203 9.40097L9.16908 10.1739L10.0193 11.6425L9.78744 12.029C9.63285 12.2609 9.55556 12.57 9.47826 12.8792L9.32367 13.2657L7.70048 13.6522V14.7343L9.32367 15.1208L9.47826 15.5072C9.55556 15.8164 9.71015 16.0483 9.78744 16.3575L10.0193 16.744L9.16908 18.2126L9.94203 18.9855L11.4106 18.1353L11.7971 18.3671C12.029 18.5217 12.3382 18.599 12.6473 18.6763L13.0338 18.8309L13.4203 20.4541Z"
                        style={{
                          fill:
                            activeButton === "Amendments"
                              ? "#2DB0D8"
                              : "#A3AED0",
                        }}
                      />
                      <path
                        d="M14 18C11.7674 18 10 16.2326 10 14C10 11.7674 11.7674 10 14 10C16.2326 10 18 11.7674 18 14C18 16.2326 16.2326 18 14 18ZM14 11.8605C12.7907 11.8605 11.8605 12.7907 11.8605 14C11.8605 15.2093 12.7907 16.1395 14 16.1395C15.2093 16.1395 16.1395 15.2093 16.1395 14C16.1395 12.7907 15.2093 11.8605 14 11.8605Z"
                        style={{
                          fill:
                            activeButton === "Amendments"
                              ? "#2DB0D8"
                              : "#A3AED0",
                        }}
                      />
                      <path
                        d="M14.5 2C14.0312 2 13.7188 2.3125 13.7188 2.78125C13.7188 3.25 14.0312 3.5625 14.5 3.5625C20.5156 3.5625 25.4375 8.48438 25.4375 14.5C25.4375 20.5156 20.5156 25.4375 14.5 25.4375C8.48438 25.4375 3.5625 20.5156 3.5625 14.5C3.5625 12.3125 4.1875 10.2031 5.4375 8.40625V9.34375C5.4375 9.8125 5.75 10.125 6.21875 10.125C6.6875 10.125 7 9.8125 7 9.34375V5.4375H3.09375C2.625 5.4375 2.3125 5.75 2.3125 6.21875C2.3125 6.6875 2.625 7 3.09375 7H4.5C2.85937 9.10937 2 11.7656 2 14.5C2 21.375 7.625 27 14.5 27C21.375 27 27 21.375 27 14.5C27 7.625 21.375 2 14.5 2Z"
                        style={{
                          fill:
                            activeButton === "Amendments"
                              ? "#2DB0D8"
                              : "#A3AED0",
                        }}
                      />
                    </svg>
                  }
                  title={translations?.message?.amendments ? translations.message.amendments : "Amendments"} 
                  isActive={activeButton === "Amendments"}
                />
              </div>
            </a>
            <a href="/dashboard/reminders">
              <div
                onClick={() => handleButtonClick("Reminders")}
                // data-aos="fade-right"
                // data-aos-duration="1600"
              >
                <SideBtn
                  svgImage={
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.0004 1.9961C13.9471 1.99354 15.8182 2.74894 17.2174 4.10226C18.6167 5.45557 19.4341 7.30048 19.4964 9.2461L19.5004 9.4961V13.5931L20.8804 16.7491C20.9634 16.9393 20.9978 17.1471 20.9804 17.3539C20.963 17.5607 20.8944 17.7598 20.7808 17.9335C20.6672 18.1071 20.5121 18.2497 20.3296 18.3485C20.1472 18.4472 19.9429 18.499 19.7354 18.4991L15.0004 18.5021C15.0015 19.2831 14.6979 20.0337 14.1542 20.5944C13.6105 21.1551 12.8696 21.4817 12.089 21.5047C11.3083 21.5278 10.5495 21.2455 9.97365 20.7178C9.39785 20.1902 9.0505 19.4588 9.00544 18.6791L9.00044 18.4991H4.27544C4.06816 18.4991 3.86413 18.4476 3.68172 18.3491C3.49931 18.2507 3.34424 18.1084 3.23048 17.9351C3.11671 17.7619 3.04783 17.563 3.03001 17.3565C3.0122 17.15 3.04603 16.9423 3.12844 16.7521L4.50044 13.5941V9.4961C4.50044 5.3411 7.85244 1.9961 12.0004 1.9961ZM13.5004 18.5001L10.5004 18.5021C10.5004 18.8874 10.6486 19.258 10.9143 19.5369C11.1801 19.8159 11.543 19.982 11.9279 20.0006C12.3127 20.0192 12.69 19.8891 12.9815 19.6371C13.2729 19.3851 13.4563 19.0306 13.4934 18.6471L13.5004 18.5001ZM12.0004 3.4961C8.68044 3.4961 6.00044 6.1701 6.00044 9.4961V13.9061L4.65644 17.0001H19.3534L18.0004 13.9071V9.5091L17.9974 9.2841C17.945 7.72951 17.2899 6.25629 16.1706 5.17608C15.0514 4.09587 13.5559 3.4934 12.0004 3.4961Z"
                        style={{
                          fill:
                            activeButton === "Reminders"
                              ? "#2DB0D8"
                              : "#A3AED0",
                        }}
                      />
                    </svg>
                  }
                  title={translations?.message?.reminders ? translations.message.reminders : "Reminders"} 
                  isActive={activeButton === "Reminders"}
                />
              </div>
            </a>

            <a href={"/dashboard/folders"}>
              <div
                onClick={() => handleButtonClick("Folders")}
                // data-aos="fade-right"
                // data-aos-duration="2500"
              >
                <SideBtn
                  svgImage={
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                      <path d="M4.39999 12.4667H10.2667V13.9333H4.39999V12.4667ZM4.39999 8.8H13.2V10.2667H4.39999V8.8ZM4.39999 16.1333H8.06666V17.6H4.39999V16.1333Z"  style={{
                          fill:
                            activeButton === "Folders"
                              ? "#2DB0D8"
                              : "#A3AED0",
                        }} />
                      <path d="M16 2.35714H13.6V1.57143C13.6 1.15466 13.4314 0.754961 13.1314 0.460261C12.8313 0.165561 12.4243 0 12 0H5.6C5.17565 0 4.76869 0.165561 4.46863 0.460261C4.16857 0.754961 4 1.15466 4 1.57143V2.35714H1.6C1.17565 2.35714 0.768687 2.5227 0.468629 2.8174C0.168571 3.1121 0 3.5118 0 3.92857V20.4286C0 20.8453 0.168571 21.245 0.468629 21.5397C0.768687 21.8344 1.17565 22 1.6 22H16C16.4243 22 16.8313 21.8344 17.1314 21.5397C17.4314 21.245 17.6 20.8453 17.6 20.4286V3.92857C17.6 3.5118 17.4314 3.1121 17.1314 2.8174C16.8313 2.5227 16.4243 2.35714 16 2.35714ZM5.6 1.57143H12V4.71429H5.6V1.57143ZM16 20.4286H1.6V3.92857H4V6.28571H13.6V3.92857H16V20.4286Z"  style={{
                          fill: 
                            activeButton === "Folders"
                              ? "#2DB0D8"
                              : "#A3AED0",
                        }} />
                    </svg>
                  }
                  title={translations?.message?.folders ? translations.message.folders : "Folders"} 
                  isActive={activeButton === "Folders"}
                />
              </div>
            </a>
            <a href={"/dashboard/search"}>
              <div
                onClick={() => handleButtonClick("Search")}
                // data-aos="fade-right"
                // data-aos-duration="2500"
              >
                <SideBtn
                  svgImage={
                    <svg
                      width="31"
                      height="31"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.8155 25.2366C19.5988 25.2366 18.5577 24.8043 17.6923 23.9397C16.8269 23.0752 16.3942 22.0337 16.3942 20.8152C16.3942 19.5967 16.8269 18.5556 17.6923 17.6919C18.5577 16.8282 19.5988 16.3955 20.8155 16.3938C22.0323 16.3921 23.0738 16.8248 23.9401 17.6919C24.8064 18.5591 25.2386 19.6002 25.2369 20.8152C25.2369 21.2922 25.1689 21.7603 25.0328 22.2192C24.8959 22.6782 24.6793 23.0945 24.3831 23.4683L27.2145 26.3009C27.335 26.4214 27.3996 26.5696 27.4082 26.7452C27.4168 26.9209 27.3522 27.0772 27.2145 27.2141C27.0767 27.351 26.9243 27.4156 26.7572 27.4079C26.5901 27.4001 26.4382 27.3355 26.3012 27.2141L23.4686 24.4073C23.0777 24.6544 22.6587 24.8547 22.2118 25.0079C21.7649 25.1612 21.2986 25.2374 20.8155 25.2366ZM20.8104 23.9449C21.6853 23.9449 22.4267 23.6431 23.0346 23.0394C23.6417 22.4358 23.9452 21.6965 23.9452 20.8216C23.9452 19.9468 23.6434 19.2053 23.0398 18.5974C22.4361 17.9894 21.6969 17.6855 20.822 17.6855C19.9471 17.6855 19.2057 17.9877 18.5977 18.5922C17.9898 19.1967 17.6858 19.936 17.6858 20.81C17.6858 21.684 17.9881 22.4255 18.5926 23.0343C19.1971 23.6431 19.9363 23.9466 20.8104 23.9449ZM7.25303 25.8333C6.67953 25.8333 6.1887 25.6288 5.78053 25.2198C5.37151 24.8116 5.16699 24.3208 5.16699 23.7473V7.25269C5.16699 6.67919 5.37151 6.18835 5.78053 5.78019C6.1887 5.37116 6.67953 5.16664 7.25303 5.16664H13.2425C13.363 4.66117 13.6313 4.23664 14.0472 3.89306C14.4631 3.54948 14.9475 3.37769 15.5003 3.37769C16.0635 3.37769 16.5517 3.54991 16.9651 3.89435C17.3784 4.23707 17.6454 4.66117 17.7659 5.16664H23.7463C24.3207 5.16664 24.8119 5.37116 25.2201 5.78019C25.6291 6.18835 25.8337 6.67919 25.8337 7.25269V13.1646C25.8337 13.3481 25.7717 13.5018 25.6477 13.6258C25.5237 13.7489 25.37 13.8105 25.1865 13.8105C25.004 13.8105 24.8507 13.7489 24.7267 13.6258C24.6027 13.5026 24.5411 13.3489 24.542 13.1646V7.25269C24.542 7.05463 24.4593 6.8725 24.294 6.70631C24.1287 6.54012 23.9465 6.45745 23.7476 6.45831H20.667V8.29635C20.667 8.59171 20.568 8.83971 20.3699 9.04035C20.1719 9.24099 19.9264 9.34088 19.6337 9.34002H11.367C11.0742 9.34002 10.8288 9.24013 10.6307 9.04035C10.4327 8.84057 10.3337 8.59257 10.3337 8.29635V6.45831H7.25303C7.05498 6.45831 6.87285 6.54098 6.70666 6.70631C6.54046 6.87164 6.4578 7.05377 6.45866 7.25269V23.7473C6.45866 23.9453 6.54133 24.1274 6.70666 24.2936C6.87199 24.4598 7.05412 24.5425 7.25303 24.5416H12.917C13.1004 24.5416 13.2537 24.6036 13.3768 24.7276C13.5 24.8516 13.562 25.0054 13.5628 25.1888C13.5637 25.3722 13.5017 25.5255 13.3768 25.6486C13.252 25.7717 13.0987 25.8333 12.917 25.8333H7.25303ZM15.5042 6.75539C15.8013 6.75539 16.0489 6.6555 16.2469 6.45573C16.445 6.25595 16.544 6.00709 16.544 5.70914C16.544 5.4112 16.4437 5.16363 16.243 4.96644C16.0424 4.76924 15.7935 4.67021 15.4964 4.66935C15.1994 4.66849 14.9518 4.76924 14.7537 4.9716C14.5557 5.17396 14.4567 5.42239 14.4567 5.71689C14.4567 6.01139 14.5574 6.25896 14.7589 6.4596C14.9604 6.66024 15.2088 6.75798 15.5042 6.75539Z"
                        style={{
                          fill:
                            activeButton === "Search" ? "#2DB0D8" : "#A3AED0",
                        }}
                      />
                    </svg>
                  }
                  title={translations?.message?.search ? translations.message.search : "Search"} 
                  isActive={activeButton === "Search"}
                />
              </div>
            </a>
            <a href={"/dashboard/notes"}>
              <div
                onClick={() => handleButtonClick("Notes")}
                // data-aos="fade-right"
                // data-aos-duration="2800"
              >
                <SideBtn
                  svgImage={
                    <svg
                      width="23"
                      height="23"
                      viewBox="0 0 23 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.3649 6.57521V12.653C20.365 12.9128 20.3138 13.1701 20.2141 13.41C20.1145 13.65 19.9683 13.8679 19.7842 14.0512L14.0514 19.7839C13.8681 19.9683 13.65 20.1145 13.4099 20.2142C13.1698 20.3139 12.9123 20.365 12.6522 20.3647H6.57641C6.05896 20.3648 5.54655 20.263 5.06845 20.065C4.59036 19.8671 4.15593 19.5769 3.78999 19.2111C3.42406 18.8452 3.13378 18.4109 2.93573 17.9328C2.73768 17.4548 2.63574 16.9424 2.63574 16.425V6.57425C2.636 5.52954 3.05118 4.5277 3.78999 3.78907C4.52881 3.05044 5.53074 2.6355 6.57545 2.6355H16.4262C17.471 2.6355 18.4731 3.05057 19.212 3.78941C19.9508 4.52825 20.3649 5.53033 20.3649 6.57521Z"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{
                          stroke:
                            activeButton === "Notes" ? "#2DB0D8" : "#A3AED0",
                        }}
                      />
                      <path
                        d="M13.4709 20.197L12.9784 16.2582C12.9219 15.8114 12.9684 15.3577 13.1143 14.9316C13.2601 14.5055 13.5015 14.1184 13.8199 13.8C14.1383 13.4815 14.5253 13.24 14.9513 13.094C15.3773 12.9481 15.8311 12.9014 16.2779 12.9577L20.2166 13.4503"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{
                          stroke:
                            activeButton === "Notes" ? "#2DB0D8" : "#A3AED0",
                        }}
                      />
                    </svg>
                  }
                  title={translations?.message?.notes ? translations.message.notes : "Notes"} 
                  isActive={activeButton === "Notes"}
                />
              </div>
            </a>
            <a href={"/dashboard/profile"}>
              {/* <div data-aos="fade-right" data-aos-duration="3000"> */}
              <div >
                <SideBtn
                  svgImage={
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_643_1746)">
                        <path
                          d="M19.4298 12.98C19.4698 12.66 19.4998 12.34 19.4998 12C19.4998 11.66 19.4698 11.34 19.4298 11.02L21.5398 9.37C21.7298 9.22 21.7798 8.95 21.6598 8.73L19.6598 5.27C19.5698 5.11 19.3998 5.02 19.2198 5.02C19.1598 5.02 19.0998 5.03 19.0498 5.05L16.5598 6.05C16.0398 5.65 15.4798 5.32 14.8698 5.07L14.4898 2.42C14.4598 2.18 14.2498 2 13.9998 2H9.99984C9.74984 2 9.53984 2.18 9.50984 2.42L9.12984 5.07C8.51984 5.32 7.95984 5.66 7.43984 6.05L4.94984 5.05C4.88984 5.03 4.82984 5.02 4.76984 5.02C4.59984 5.02 4.42984 5.11 4.33984 5.27L2.33984 8.73C2.20984 8.95 2.26984 9.22 2.45984 9.37L4.56984 11.02C4.52984 11.34 4.49984 11.67 4.49984 12C4.49984 12.33 4.52984 12.66 4.56984 12.98L2.45984 14.63C2.26984 14.78 2.21984 15.05 2.33984 15.27L4.33984 18.73C4.42984 18.89 4.59984 18.98 4.77984 18.98C4.83984 18.98 4.89984 18.97 4.94984 18.95L7.43984 17.95C7.95984 18.35 8.51984 18.68 9.12984 18.93L9.50984 21.58C9.53984 21.82 9.74984 22 9.99984 22H13.9998C14.2498 22 14.4598 21.82 14.4898 21.58L14.8698 18.93C15.4798 18.68 16.0398 18.34 16.5598 17.95L19.0498 18.95C19.1098 18.97 19.1698 18.98 19.2298 18.98C19.3998 18.98 19.5698 18.89 19.6598 18.73L21.6598 15.27C21.7798 15.05 21.7298 14.78 21.5398 14.63L19.4298 12.98ZM17.4498 11.27C17.4898 11.58 17.4998 11.79 17.4998 12C17.4998 12.21 17.4798 12.43 17.4498 12.73L17.3098 13.86L18.1998 14.56L19.2798 15.4L18.5798 16.61L17.3098 16.1L16.2698 15.68L15.3698 16.36C14.9398 16.68 14.5298 16.92 14.1198 17.09L13.0598 17.52L12.8998 18.65L12.6998 20H11.2998L11.1098 18.65L10.9498 17.52L9.88984 17.09C9.45984 16.91 9.05984 16.68 8.65984 16.38L7.74984 15.68L6.68984 16.11L5.41984 16.62L4.71984 15.41L5.79984 14.57L6.68984 13.87L6.54984 12.74C6.51984 12.43 6.49984 12.2 6.49984 12C6.49984 11.8 6.51984 11.57 6.54984 11.27L6.68984 10.14L5.79984 9.44L4.71984 8.6L5.41984 7.39L6.68984 7.9L7.72984 8.32L8.62984 7.64C9.05984 7.32 9.46984 7.08 9.87984 6.91L10.9398 6.48L11.0998 5.35L11.2998 4H12.6898L12.8798 5.35L13.0398 6.48L14.0998 6.91C14.5298 7.09 14.9298 7.32 15.3298 7.62L16.2398 8.32L17.2998 7.89L18.5698 7.38L19.2698 8.59L18.1998 9.44L17.3098 10.14L17.4498 11.27ZM11.9998 8C9.78984 8 7.99984 9.79 7.99984 12C7.99984 14.21 9.78984 16 11.9998 16C14.2098 16 15.9998 14.21 15.9998 12C15.9998 9.79 14.2098 8 11.9998 8ZM11.9998 14C10.8998 14 9.99984 13.1 9.99984 12C9.99984 10.9 10.8998 10 11.9998 10C13.0998 10 13.9998 10.9 13.9998 12C13.9998 13.1 13.0998 14 11.9998 14Z"
                          style={{
                            fill:
                              activeButton === "Settings" ? "#2DB0D8" : "#A3AED0",
                          }}
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_643_1746">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  }
                  title={translations?.message?.settings ? translations.message.settings : "Settings"} 
                />
              </div>
            </a>
            
            {/* <a href={"/dashboard/chatbot"}>
              <div
                onClick={() => handleButtonClick("Chatbot")}
                data-aos="fade-right"
                data-aos-duration="2500"
              >
                <SideBtn
                  svgImage={
                    <svg
                      width="23"
                      height="23"
                      viewBox="0 0 23 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.3649 6.57521V12.653C20.365 12.9128 20.3138 13.1701 20.2141 13.41C20.1145 13.65 19.9683 13.8679 19.7842 14.0512L14.0514 19.7839C13.8681 19.9683 13.65 20.1145 13.4099 20.2142C13.1698 20.3139 12.9123 20.365 12.6522 20.3647H6.57641C6.05896 20.3648 5.54655 20.263 5.06845 20.065C4.59036 19.8671 4.15593 19.5769 3.78999 19.2111C3.42406 18.8452 3.13378 18.4109 2.93573 17.9328C2.73768 17.4548 2.63574 16.9424 2.63574 16.425V6.57425C2.636 5.52954 3.05118 4.5277 3.78999 3.78907C4.52881 3.05044 5.53074 2.6355 6.57545 2.6355H16.4262C17.471 2.6355 18.4731 3.05057 19.212 3.78941C19.9508 4.52825 20.3649 5.53033 20.3649 6.57521Z"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{
                          stroke:
                            activeButton === "Chatbot" ? "#2DB0D8" : "#A3AED0",
                        }}
                      />
                      <path
                        d="M13.4709 20.197L12.9784 16.2582C12.9219 15.8114 12.9684 15.3577 13.1143 14.9316C13.2601 14.5055 13.5015 14.1184 13.8199 13.8C14.1383 13.4815 14.5253 13.24 14.9513 13.094C15.3773 12.9481 15.8311 12.9014 16.2779 12.9577L20.2166 13.4503"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{
                          stroke:
                            activeButton === "Chatbot" ? "#2DB0D8" : "#A3AED0",
                        }}
                      />
                    </svg>
                  }
                  title={"Chatbot"}
                  isActive={activeButton === "Chatbot"}
                />
              </div>
            </a> */}
          </Menu>
        ) : (
          <div className="filterSidebar">

          <div className="logo-filter-sidebar">
          <Link
              reloadDocument
              to={"/dashboard"}
              style={{ width: "100%" }}
              className="text-center"
            >
              <img src={logo} />
            </Link>
          </div>

            {
             lastSegment !== "search" && !window.location.pathname.includes("regulation/") && (
              <>
                <h1 className="filter-title">{ translations?.message?.search ? translations.message.search : "Search"  }</h1>
                <input
                  onChange={handleSearchChange}
                  type="search"
                  className="filter-sidebar-search"
                  placeholder={ translations?.message?.search ? translations.message.search : "Search"  }
                  value={searchQuery}
                />
              </>
             )
            }
              


              { !window.location.pathname.match(pattern) &&
              <>
              {(loading || (areas_of_law && areas_of_law.length > 0)) && <h1 className="filter-title">
               
                {translations?.message?.areaOfLaw ? translations.message.areaOfLaw : "Area of law"} 

                </h1>}
              {loading ? (
                <>
                  <div style={{ width: "100%" }}>
                    <Skeleton animation="wave" height={16} width={'100%'} className="custom-skeleton" />
                    <Skeleton animation="wave" height={16} width={'100%'} className="custom-skeleton" />
                    <Skeleton animation="wave" height={16} width={'100%'} className="custom-skeleton" />
                  </div>
                </>
              ) :
              (
                  <div className='results-reports'>
                    {<>
                      {areas_of_law.map((item, index) => (
                        <CheckLabel
                          key={index}
                          value={item}
                          name={item.name}
                          checked={handleExist("area_of_laws", item.id)}
                          // count={"50"}
                          selectedFilters={selectedFilters.areas_of_law || []}
                          onCheckboxChange={() =>
                            handleCheckboxChange("area_of_laws", item.id)
                          }
                        />
                      ))}
                    </>

                    }
                  </div>
              )}
              {(loading || (topics && topics.length > 0)) && <h1 className="filter-title">
                {translations?.message?.topic ? translations.message.topic : "Topic"} 
                </h1>}
              {loading ? (
                <>
                  <div style={{ width: "100%" }}>
                    <Skeleton animation="wave" height={16} width={'100%'} className="custom-skeleton" />
                    <Skeleton animation="wave" height={16} width={'100%'} className="custom-skeleton" />
                    <Skeleton animation="wave" height={16} width={'100%'} className="custom-skeleton" />
                  </div>
                </>
              ) :
              (
                  <div className='results-reports'>
                    {<>
                      {topics.map((item, index) => (
                        <CheckLabel
                          key={index}
                          value={item}
                          name={item.name}
                          // count={"20"}
                          checked={handleExist("topics", item.id)}
                          selectedFilters={selectedFilters.topics || []}
                          onCheckboxChange={() =>
                            handleCheckboxChange("topics", item.id)
                          }
                        />
                      ))}
                    </>

                    }
                  </div>
              )}
              {(loading || (jurisdictions && jurisdictions.length > 0)) && <h1 className="filter-title">
                {translations?.message?.jurisdiction ? translations.message.jurisdiction : "Jurisdiction"} 
                </h1>}
              {loading ? (
                <>
                  <div style={{ width: "100%" }}>
                    <Skeleton animation="wave" height={16} width={'100%'} className="custom-skeleton" />
                    <Skeleton animation="wave" height={16} width={'100%'} className="custom-skeleton" />
                    <Skeleton animation="wave" height={16} width={'100%'} className="custom-skeleton" />
                  </div>
                </>
              ) :
              (
                <div className='results-reports'>
                  {<>
                    {jurisdictions.map((item, index) => (
                      <CheckLabel
                        key={index}
                        value={item}
                        name={item.name}
                        // count={"20"}
                        checked={handleExist("jurisdictions", item.id)}
                        selectedFilters={selectedFilters.jurisdiction || []}
                        onCheckboxChange={() =>
                          handleCheckboxChange("jurisdictions", item.id)
                        }
                      />
                    ))}
                  </>

                    }
                  </div>
              )}
              


            {/* {window.location.pathname.match(pattern) && <button className='apply-btn' onClick={() => handleApplyFilters()}>
              Apply Filters
            </button>} */}
            {/* <CheckLabel name={"Employment Standards"} count={"20"} />
            <CheckLabel name={"Accessibility"} count={"20"} /> */}
          </>}
          </div>
        )}
      </Sidebar>
      <Modal
        isOpen={showPopup}
        onRequestClose={togglePopup}
        contentLabel="Select Filter Popup"
      >
        <UnderDevelopment btnClick={togglePopup} translations={translations} />
      </Modal>
      <SubModal
          open={subPopup}
          onClose={handleCloseSubPopup}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
          >
          <Box className="subpopup-container">
                <p className='subpopup-text'>
                {
                    messagePopup ? messagePopup : "your subscription has expired"
                }
                </p>
                <a className='subpopup-link' href='/pricing'>Go To Pricing</a>
            </Box>
      </SubModal>
    </div>
  );
};

export default SideBar;
